export const telMask = (value) => {
    if (!value) return ""
    let mask = value.replace(/\D/g,'')
    mask = mask.replace(/(\d{2})(\d)/,"($1) $2")
    mask = mask.slice(0, 14);
    mask = mask.replace(/(\d)(\d{4})$/,"$1-$2")
    return mask
  }